import { Checkbox } from '@byecode/ui'
import React from 'react'

import { Unit } from '../Mics'

export const Children: React.FC = () => {
    return (
        <Unit title="带 Label 的">
            <Checkbox size="xs">男</Checkbox>
            <Checkbox size="sm">女</Checkbox>
            <Checkbox>未知</Checkbox>
        </Unit>
    )
}
